import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"logo-wrap\"><a href=\"#\"><img src=\"img/logo.png\"></a></div><hr><div class=\"login-header mb-2\"><div><h1>Forgot password?</h1><p class=\"text-muted\"><small>Don&#39;t worry. We&#39;ll email you a password reset link with instructions.</small></p></div></div>", 3)
const _hoisted_6 = { class: "form-wrap pt-0" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "modal-wrap default-modal success-modal" }
const _hoisted_9 = {
  class: "modal fade show",
  "data-keyboard": "false",
  id: "forgetSuccessModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-modal": "true",
  role: "dialog",
  "aria-hidden": "true",
  "data-backdrop": "static"
}
const _hoisted_10 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "modal-body text-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "success-body mb-2" }, [
    /*#__PURE__*/_createVNode("img", { src: "app/img/checked.png" }),
    /*#__PURE__*/_createVNode("h5", null, "Success"),
    /*#__PURE__*/_createVNode("p", null, "Please check your email to recover password.")
  ])
], -1)
const _hoisted_15 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.error.validationList,
            hasError: _ctx.state.ui.error.hasError
          }, null, 8, ["errors", "hasError"]),
          _createVNode("div", _hoisted_7, [
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Enter your email address",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.emailAddress = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendForgetPasswordForVerification && _ctx.sendForgetPasswordForVerification(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.state.data.emailAddress]
            ])
          ])
        ]),
        _createVNode("a", {
          href: "javascript:void(0)",
          class: "btn button-gradient d-block",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendForgetPasswordForVerification && _ctx.sendForgetPasswordForVerification(...args)))
        }, _toDisplayString(_ctx.state.ui.postLoading.sendForgetPasswordForVerification
            ? "Sending..."
            : "Send verification email"), 1)
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideSuccessForgetPassword && _ctx.hideSuccessForgetPassword(...args)))
              }, [
                _hoisted_13
              ])
            ]),
            _hoisted_14,
            _createVNode("div", _hoisted_15, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn w-100",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideSuccessForgetPassword && _ctx.hideSuccessForgetPassword(...args)))
              }, " Continue ")
            ])
          ])
        ])
      ])
    ])
  ]))
}